import { render, staticRenderFns } from "./FeedReviews.vue?vue&type=template&id=07d957b8&scoped=true&"
import script from "./FeedReviews.vue?vue&type=script&lang=ts&"
export * from "./FeedReviews.vue?vue&type=script&lang=ts&"
import style0 from "./FeedReviews.vue?vue&type=style&index=0&id=07d957b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d957b8",
  null
  
)

export default component.exports